module.exports = __webpack_public_path__ + "img/sfl-logo.ff88f22a.png";